<script setup>
import { useElementVisibility } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

// Components
import CounterItems from '@/Components/Blocks/Counter/CounterItems.vue';
import { usePage } from '@inertiajs/vue3';
import AddOnLabel from '@/Components/AddOnLabel.vue';

const props = defineProps({
    counters: Array,
    addOnLabel: Boolean,
});

const { t } = useI18n();
const counterItemsComponent = ref(null);
const isCounterVisible = useElementVisibility(counterItemsComponent);

const moduleActive = computed(() => usePage().props.template_options.modules.counter_component_active);
</script>

<template>
    <div class="text-white bg-black" :class="{ 'relative  ': addOnLabel }" v-if="moduleActive && counters">
        <div class="container py-12 md:py-16">
            <AddOnLabel v-if="addOnLabel" />

            <CounterItems :ref="'counterItemsComponent'" :animationPaused="isCounterVisible" :counters="counters" />
        </div>
    </div>
</template>
